export default __webpack_public_path__ + "static/media/E-Furnished.4fd6617f.png";